import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@hn-ui/tooltips';
import { SkillStatus } from '../../constants/statuses';
import { COLUMN_WIDTH, FILTER_COLUMN_ID, LAST_COLUMN_WIDTH, } from '../../constants/table';
var SKILL_COLUMN_ID_DELIMITER = '|';
var checkIfStudentRow = function (data) {
    return data.skills !== undefined;
};
var filterByStudentWhoNeedHelp = function (rows, ids, filterValue) {
    return rows.filter(function (_a) {
        var values = _a.values;
        return filterValue.includes(values[FILTER_COLUMN_ID]);
    });
};
var createSkillColumnId = function (skill) {
    return [skill.name, skill.id].join(SKILL_COLUMN_ID_DELIMITER);
};
var getSkillDataFromColumnId = function (skillColumnId) {
    return skillColumnId.split(SKILL_COLUMN_ID_DELIMITER);
};
var defaultSort = function (a, b) {
    var _a, _b, _c, _d;
    var skillsCountA = a.skills.length;
    var skillsCountB = b.skills.length;
    if (skillsCountA > skillsCountB)
        return -1;
    if (skillsCountB > skillsCountA)
        return 1;
    if (skillsCountA === skillsCountB && skillsCountA > 0 && skillsCountB > 0) {
        var aLastSkillPosition = (_b = (_a = a.skills[skillsCountA - 1]) === null || _a === void 0 ? void 0 : _a.position) !== null && _b !== void 0 ? _b : 0;
        var bLastSkillPosition = (_d = (_c = b.skills[skillsCountB - 1]) === null || _c === void 0 ? void 0 : _c.position) !== null && _d !== void 0 ? _d : 0;
        if (aLastSkillPosition > bLastSkillPosition)
            return -1;
        if (bLastSkillPosition > aLastSkillPosition)
            return 1;
    }
    return 0;
};
var sortByRating = function (rowA, rowB, columnId, desc) {
    var _a, _b, _c, _d;
    var _e = getSkillDataFromColumnId(columnId), _name = _e[0], id = _e[1];
    var ratingA = (_b = (_a = rowA.skills.find(function (el) { return String(el.skillId) === id; })) === null || _a === void 0 ? void 0 : _a.rating) !== null && _b !== void 0 ? _b : 0;
    var ratingB = (_d = (_c = rowB.skills.find(function (el) { return String(el.skillId) === id; })) === null || _c === void 0 ? void 0 : _c.rating) !== null && _d !== void 0 ? _d : 0;
    if (ratingA === 0 && ratingB === 0)
        return 0;
    if (desc === false) {
        if (ratingA === 0)
            return 1;
        if (ratingB === 0)
            return -1;
    }
    if (ratingA > ratingB)
        return desc ? -1 : 1;
    if (ratingB > ratingA)
        return desc ? 1 : -1;
    return 0;
};
var getRowId = function (data) {
    return "student-skills-row-" + data.id.toString();
};
var getAdditionalRowProps = function (_a) {
    var original = _a.original;
    var isStudent = checkIfStudentRow(original);
    return {
        id: isStudent ? getRowId(original) : original.name,
        'data-hoverable': String(isStudent),
    };
};
var checkIfStudentHasNoData = function (row) {
    return checkIfStudentRow(row.original) &&
        row.original.skills.every(function (el) { return el.status === SkillStatus.NoData; });
};
var calculateNoActivityTooltipVirtualElement = function (rowEl) {
    var studentNameCell = rowEl.children[0];
    return {
        getBoundingClientRect: function () {
            return {
                width: rowEl.getBoundingClientRect().width -
                    studentNameCell.getBoundingClientRect().width -
                    LAST_COLUMN_WIDTH,
                height: rowEl.getBoundingClientRect().height,
                x: rowEl.getBoundingClientRect().x +
                    studentNameCell.getBoundingClientRect().width,
                y: rowEl.getBoundingClientRect().y,
                top: rowEl.getBoundingClientRect().top,
                left: rowEl.getBoundingClientRect().left +
                    studentNameCell.getBoundingClientRect().width,
                bottom: rowEl.getBoundingClientRect().bottom,
                right: rowEl.getBoundingClientRect().right - LAST_COLUMN_WIDTH,
            };
        },
        contextElement: rowEl,
    };
};
var renderRowTooltip = function (row) {
    var hasNoData = checkIfStudentHasNoData(row);
    if (!hasNoData)
        return null;
    var rowId = getAdditionalRowProps(row).id;
    var rowEl = document.getElementById(rowId);
    if (!rowEl)
        return null;
    return (_jsx(Tooltip, { placement: 'top', followCursor: true, maxWidth: '157px', content: 'No activity yet', virtualElement: calculateNoActivityTooltipVirtualElement(rowEl) }, void 0));
};
var getGradeSkillLevel = function (gradeValue, groupGradeValue) {
    if (gradeValue > groupGradeValue)
        return 'above';
    if (gradeValue === groupGradeValue)
        return 'on';
    return 'below';
};
var checkIfCurrentGradesRangeStarted = function (_a) {
    var level = _a.level, minGradeValue = _a.minGradeValue, maxGradeValue = _a.maxGradeValue, students = _a.students;
    return students.some(function (student) {
        return student.skills.some(function (skill) {
            return skill.status !== SkillStatus.NoData &&
                skill.level === level &&
                skill.gradeValue >= minGradeValue &&
                skill.gradeValue <= maxGradeValue;
        });
    });
};
var calculateLevelLabelWidth = function (renderedGrades, level, groupGradeValue) {
    return renderedGrades.reduce(function (acc, grade) {
        var gradeLevel = getGradeSkillLevel(grade.value, groupGradeValue);
        if (gradeLevel === level)
            acc += grade.skills.length * COLUMN_WIDTH - 2;
        return acc;
    }, 0);
};
var getFilterColumns = function (students) { return [
    {
        id: FILTER_COLUMN_ID,
        accessor: function (data) {
            if (!checkIfStudentRow(data)) {
                return String(students.some(function (student) {
                    return student.level === data.level &&
                        student.skills.some(function (skill) { return skill.status === SkillStatus.HelpNeeded; });
                }));
            }
            return String(data.skills.some(function (el) { return el.status === SkillStatus.HelpNeeded; }));
        },
        disableSortBy: true,
        filter: filterByStudentWhoNeedHelp,
    },
]; };
export { checkIfStudentRow, createSkillColumnId, getSkillDataFromColumnId, defaultSort, sortByRating, filterByStudentWhoNeedHelp, renderRowTooltip, getAdditionalRowProps, getGradeSkillLevel, checkIfCurrentGradesRangeStarted, calculateLevelLabelWidth, getFilterColumns, };
